/**
 * WordPress dependencies
 */
import { Component, Fragment } from '@wordpress/element';
import { JustifyContentControl, BlockControls } from '@wordpress/block-editor';

/**
 * Inner dependencies.
 */

/**
 * Inspector controls
 */
class Inspector extends Component {
	render() {
		const { attributes, setAttributes } = this.props;
		const { contentJustification, orientation } = attributes;
		const VERTICAL_JUSTIFY_CONTROLS = [ 'left', 'center', 'right' ];
		const HORIZONTAL_JUSTIFY_CONTROLS = [
			'left',
			'center',
			'right',
			'space-between',
		];
		const justifyControls = orientation === 'vertical'
			? VERTICAL_JUSTIFY_CONTROLS
			: HORIZONTAL_JUSTIFY_CONTROLS;
		return (
			<Fragment>
				<BlockControls>
					<JustifyContentControl
						allowedControls={ justifyControls }
						value={ contentJustification }
						onChange={ ( value ) =>
							setAttributes( { contentJustification: value } )
						}
						popoverProps={ {
							position: 'bottom right',
							isAlternate: true,
						} }
					/>
				</BlockControls>
			</Fragment>
		);
	}
}

export default Inspector;
